import { BannerCard } from '@design-system';

import { getUrlHost, isAbsoluteUrl, isValidUrl } from '../../utils/urlHelpers';

interface Props {
  item: ImageCardLinkBlok;
  onClick?: (href: string, title?: string) => void;
}

export const ImageCardLink = ({ item, onClick }: Props) => {
  const linkUrl = item.url?.cached_url || '';
  const isAbsolute = isAbsoluteUrl(linkUrl);
  const isValidLink = isValidUrl(isAbsolute ? linkUrl : `/${linkUrl}`);

  if (isValidLink) {
    return (
      <BannerCard
        as="a"
        aspectRatioClassName="aspect-[4/3]"
        description={
          item.variant === 'external' ? getUrlHost(linkUrl) : item.description
        }
        href={isAbsolute ? linkUrl : `/${linkUrl}`}
        image={item.image}
        onClick={() =>
          onClick?.(isAbsolute ? linkUrl : `/${linkUrl}`, item.title)
        }
        target={item.tab ? '_blank' : '_self'}
        title={item.title}
        variant="image"
      />
    );
  }

  return (
    <BannerCard
      as="a"
      aspectRatioClassName="aspect-[4/3]"
      description={
        item.variant === 'external' ? getUrlHost(linkUrl) : item.description
      }
      href="#"
      image={item.image}
      target={item.tab ? '_blank' : '_self'}
      title={item.title}
      variant="image"
    />
  );
};
